import React from "react";

import { pickRowValue } from "../../utils/tableColumnValue";

const badge =
  "inline-flex items-center max-w-[200px] truncate px-2 py-0.5 rounded-full text-xs font-medium border";

function labelOrDash(v) {
  if (v == null || String(v).trim() === "") return "—";
  return String(v).trim();
}

/** `row.type`: `buyer` | `seller` */
export function freightFormRequestTypeBadgeCell(row) {
  const t = String(row?.type || "").toLowerCase();
  if (!t) return <span className="text-gray-400">—</span>;
  const isBuyer = t === "buyer";
  const cls = isBuyer
    ? "border-sky-200 bg-sky-50 text-sky-900"
    : "border-violet-200 bg-violet-50 text-violet-900";
  const label = isBuyer ? "Buyer" : t === "seller" ? "Seller" : t;
  return (
    <span className={`${badge} ${cls}`} title={label}>
      {label}
    </span>
  );
}

/** Derive status code from server-rendered `status` HTML when raw code is absent. */
export function freightFormRequestStatusCodeFromRow(row) {
  const raw = row?.status_code ?? row?.form_status;
  if (raw != null && raw !== "") return String(raw).trim();
  const html = row?.status;
  if (html == null || html === "") return "0";
  const s = String(html);
  if (/bg-success|badge[^>]*success|Complete/i.test(s)) return "1";
  if (/bg-danger|badge[^>]*danger|Rejected/i.test(s)) return "2";
  return "0";
}

/** Server sends Bootstrap badge HTML; render like other admin columns that use `html: true`. */
export function freightFormRequestStatusHtmlCell(row) {
  const html = pickRowValue(row, { key: "status", aliases: [] });
  if (html == null || html === "") return <span className="text-gray-400">—</span>;
  return <span dangerouslySetInnerHTML={{ __html: String(html) }} />;
}

export function freightFormRequestQtyCell(row) {
  return <span className="tabular-nums">{labelOrDash(row?.qty)}</span>;
}
